<template>
  <SeoPage page-key="sitiWebResponsiveTicino" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'SitiWebResponsiveTicinoPage'
})
</script>

